import { useCallback, useEffect, useState } from 'react';

/**
 * 설정의 「홈에서 미리보기」 (v32 · `docs/63` §5.5). **`ads/ads-enabled.ts` 의 모양 그대로다.**
 *
 * 서버에도 계정에도 저장하지 않는다 — `localStorage` 한 키다. 기본은 **켬**이고, 읽기가
 * 실패해도(사파리 프라이빗) 켬이다.
 */
const STORAGE_KEY = 'bloom.homePreview';
const CHANGE_EVENT = 'bloom:home-preview';

/** 저장된 원문 → 켜짐. **순수** — `'false'` 만 끔이고 나머지(없음 · 잘못된 값)는 켬이다. */
export function parseHomePreview(raw: string | null): boolean {
  return raw !== 'false';
}

export function homePreviewEnabled(): boolean {
  try {
    return parseHomePreview(localStorage.getItem(STORAGE_KEY));
  } catch {
    return true;
  }
}

export function setHomePreviewEnabled(next: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false');
  } catch {
    // 저장소가 막힌 환경 — 이 세션에서만 산다
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
}

export function useHomePreviewEnabled(): [boolean, (next: boolean) => void] {
  const [enabled, setEnabled] = useState(homePreviewEnabled);
  useEffect(() => {
    const sync = () => {
      setEnabled(homePreviewEnabled());
    };
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  const set = useCallback((next: boolean) => {
    setHomePreviewEnabled(next);
    setEnabled(next);
  }, []);
  return [enabled, set];
}
